import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-document-lookup',
	templateUrl: './document-lookup.component.html',
	styleUrls: ['./document-lookup.component.scss']
})
export class DocumentLookupComponent implements OnInit {
	color = '';
	formGroup: UntypedFormGroup;
	isrunning = false;
	searched = false;
	results: any = false;

	constructor(
		private location: Location,
		private router: Router,
		private route: ActivatedRoute,
		private fb: UntypedFormBuilder,
		private generalLedgerService: GeneralLedgerService,
		private globalSearchService: GlobalSearchService,
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.formGroup = this.fb.group({
			number: ['', [Validators.required]],
		});

		// Deep-link: ?number=NNN runs the lookup on load (e.g. from a GL inquiry line).
		const qNumber = this.route.snapshot.queryParamMap.get('number');
		if (qNumber) {
			this.formGroup.get('number').setValue(qNumber);
			this.search();
		}
	}

	back() {
		this.location.back();
	}

	search() {
		const number = ('' + (this.formGroup.get('number').value || '')).trim();
		if (!number) {
			return;
		}
		this.isrunning = true;
		this.searched = false;
		this.generalLedgerService.lookupDocument({ number }).subscribe((results: any) => {
			this.isrunning = false;
			this.searched = true;
			this.results = results;
		}, () => {
			this.isrunning = false;
			this.searched = true;
			this.results = false;
		});
	}

	totalHits(): number {
		if (!this.results || !this.results.counts) {
			return 0;
		}
		return (this.results.counts.ar || 0) + (this.results.counts.ap || 0) + (this.results.counts.gl || 0);
	}

	openCustomer(debtorno: any) {
		if (debtorno == null || debtorno === '') {
			return;
		}
		this.router.navigate(['/customers/view', debtorno]);
	}

	openVendor(supplierno: any) {
		if (supplierno == null || supplierno === '') {
			return;
		}
		this.router.navigate(['/vendors', supplierno]);
	}

	openGlAccount(accountcode: any) {
		if (accountcode == null || accountcode === '') {
			return;
		}
		this.router.navigate(['/general-ledger/account-inquiry'], { queryParams: { accountcode } });
	}
}
